import { render, staticRenderFns } from "./DealsTable.vue?vue&type=template&id=64555687&"
import script from "./DealsTable.vue?vue&type=script&lang=js&"
export * from "./DealsTable.vue?vue&type=script&lang=js&"
import style0 from "./DealsTable.vue?vue&type=style&index=0&id=64555687&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports